<template>
  <label class="toggle-switch">
    <input class="toggle-switch-input" type="checkbox"
        :checked="checked"
        @click="onToggle"
    >
    <span class="toggle-switch-element"></span>
    <div class="toggle-switch-label"><slot></slot></div>
  </label>
</template>

<script>
export default {
  props: {
    callback: {
      type: Function,
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onToggle() {
      this.callback(!this.checked)
    }
  }
}
</script>
